import React from 'react';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import NativeSelect from '@material-ui/core/NativeSelect';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import Card from '../../../Helper/CardWrapper/cardWrapper';
import converter from '../../../Helper/convertFile';
import categories from '../../../categories.json';
import './events.css';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import {connect} from 'react-redux';

const styles=theme=>({
    avatar: {
        margin: 0,
        padding:0,
        backgroundColor:'#000',
        color:'#fff',
        width: '50px',
        fontSize: '36px',
        height: '50px'
    },
    progress: {
        margin: 2,
        color:'#fff',
        fontWeight:500
    },
    textField: {
        marginTop: 0,
        fontSize: '1.6em',
        marginBottom: 0,
        // width: 135,
    },
    label:{
        fontSize:'1.5em',
        color:'#000',
        fontWeight:600,
    },
    formControl: {
        margin: theme.spacing.unit,
        display:'flex',
        flex:1
    },
    grid:{
        width: '100%'
    },
  inputText: {
        fontSize: '15px',
        // width: 120
    },  cancelButton: {
        color: '#000',
        fontSize:'medium',
        marginBottom:'3%',
        textTransform:'none'
    },

  nativeSelect:{
    fontSize:'14px',
  },

  pickerFont:{
    fontSize:'1.6rem'
  }
});

class EventForm extends React.Component {
  constructor(props){
    super(props);
    this.state={
      data:{
        Add1:'',Add2:'',Region:'',city:'',country:'',postal_code:'',
        startDateTime:moment(new Date(),'MM/dd/yyyy hh:mm a'),
        endDateTime:moment(new Date(),'MM/dd/yyyy hh:mm a').add(1,'minutes')
      },
      Initial:{
        Add1:'',Add2:'',Region:'',city:'',country:'',postal_code:'',
        startDateTime:moment(new Date(),'MM/dd/yyyy hh:mm a'),
        endDateTime:moment(new Date(),'MM/dd/yyyy hh:mm a').add(1,'minutes')
      },
      buttonText:'Create Event',
      address:[],
      cancel:false,
      file:{},
      errors:[]
    }
  }

  componentWillReceiveProps(nextProps){
    let { address } = this.state;
    let data = {};
    if(nextProps.upDated){
      data={...nextProps.editData};
      data['startDateTime']=moment(moment.utc(data.startDateTime,'MM/dd/yyyy hh:mm a').toDate()).local().format('MM/dd/yyyy hh:mm a');
      data['endDateTime']=moment(moment.utc(data.endDateTime,'MM/dd/yyyy hh:mm a').toDate()).local().format('MM/dd/yyyy hh:mm a');
      address=data["Add1"] + ", " + data["Add2"] + ", " + data["Region"] + ", " + data["City"];
      address=address.replace(/^,\s+|,\s+$/g, "");
      this.setState({
        data: {...nextProps.editData, },
        address,
        buttonText: 'Update Event'
      })
    }
    else {
      this.setState({
        data:{...this.state.Initial},
        cancel:true,
        address:'',
        buttonText: 'Create Event'
      })
    }

  }

  handleChange=(e)=>{
    e.preventDefault();
    e.stopPropagation();
    const { name,value } = e.target;
    const { data,errors } = this.state;
    errors['common']='';
    if(name==='LogoURL'){
      if(e.target.files[0].type.startsWith('image/')) {
        converter.toBase64(e.target.files[0]).then((dt) => {
          this.setState({
            data: {...data, tempURL: dt, [name]: dt.substring(dt.indexOf(',') + 1)}
          })
        });
        errors[name] = '';
      }
      else{
        errors[name]='File Should be an image.';
        data[name] = "";
      }
    }
    if(name==='Name'){
      if(value.length>50)
        errors[name]='Title must be of 50 Characters or less.';
      else if(!/[A-Za-z]/.test(value))
        errors[name]='Not a Single Alphabet is there.';
      else {
        errors[name] = '';
        data[name] = value;
      }
    }
    if(name==='Description'){
        errors[name] = '';
        data[name] = value;
    }
    else
      data[name]=value;
    this.setState({
      data,
      errors
    });
    e.target.value = '';
  };

  handleStartDate = (date) => {
    const { data } = this.state;
    if(this.validateEndDate(date,moment(data.endDateTime))===1)
      data.endDateTime=moment(date).add(1,'minutes');
    else  if(this.validateEndDate(date,moment(data.endDateTime))===2)
      data.endDateTime=moment().add(1,'minutes');
    data.startDateTime=date;
    this.setState({ data });
  };

  handleEndDate=(date)=>{
    const { data,errors } = this.state;
    var endDate = moment(date)
    if(endDate.diff(moment(), 'minutes')<1) {
      data.endDateTime = moment().add(1, 'minutes');
      errors['endDateTime']="Cannot Select Time less than current time.";
    }
    else if(this.validateEndDate(data.startDateTime,date)===1) {
      data.endDateTime = moment(data.startDateTime).add(1, 'minutes');
      errors['endDateTime']="";
    }
    else if (this.validateEndDate(data.startDateTime,date)===2){
      errors['endDateTime']="End Date should be within 1 Month of Start Date."
    }
    else {
      errors['endDateTime']="";
      data.endDateTime = date;
    }
    this.setState({ data,errors });
  };

  validateEndDate=(startDate,endDate)=>{
    if(moment(startDate).diff(endDate,'months')===0) {
      let difference = moment(endDate).diff(startDate, 'minutes');
      if (difference < 0)
        return 1;
      else
        return 0;
    }
    else{
      return 2;
    }
  };

    handleAddressSelect=(address)=>{
    const { data } = this.state;
        data["Add1"]="";
        data["Add2"]="";
        data["Region"]="";
        data["City"]="";
        let addr=address.results[0];
        data['Latitude']=address.lat.toFixed(5);
        data['Longitude']=address.lng.toFixed(5);
        addr.address_components.map((add)=>{
            if(add.types[0]==='country')
                data['country']=add.long_name;
            if(add.types[0]==='postal_code')
                data['postal_code']=add.long_name;
            if(add.types[0]==='locality')
                data['City']=add.long_name;
            if(add.types[0]==='administrative_area_level_1')
                data['Region']=add.short_name;
            if(add.types[0]==='administrative_area_level_2')
                data['Add2']=add.short_name;
            if(add.types[0]==='street_number')
                data['Add1']=add.long_name;
            if(add.types[0]==='route')
                data['Add1']+=' '+add.long_name;
        });
    };

  createDictionary=()=>{
    const { data } = this.state;
    const { user } = this.props;
    data['createdDateTime']="";
    data['startDateTime']=moment(data['startDateTime']).utc().format('DD-MMM-YYYY hh:mm A');
    data['endDateTime']=moment(data['endDateTime']).utc().format('DD-MMM-YYYY hh:mm A');
    data['UserId']=user.results.AppUser.UserId;
    data['UserLat']=user.results.AppUser.Latitude;
    data['UserLon']=user.results.AppUser.Longitude;
    data['Capacity'] = 0;
    data['Currency'] = 200;
    data['EventType'] = 'Public';
    data['Status'] = 200;
    data['EventVenueId'] = data["EventVenueName"]||'';
    data['changedDateTime'] = "";
    data['invitedPersonIDs'] = "";
    data['ticketsURL'] = "";
    return data;
  };

  createEditDictionary=()=>{
    const { data } = this.state;
    const { user } = this.props;
    data['startDateTime']=moment(data['startDateTime']).utc().format('DD-MMM-YYYY hh:mm A');
    data['endDateTime']=moment(data['endDateTime']).utc().format('DD-MMM-YYYY hh:mm A');
    data['UserId']=user.results.AppUser.UserId;
    data['userLat']=user.results.AppUser.Latitude;
    data['userLon']=user.results.AppUser.Longitude;
    data['Capacity'] = 0;
    data['Currency'] = 200;
    data['EventType'] = 'Public';
    data['Status'] = 200;
    data['changedDateTime'] = "";
    data['invitedPersonIDs'] = "";
    data['eventId'] = data["EventId"];
    data['eventCategoryId'] = data["EventCategoryId"];
    data['EventVenueId'] = data["EventVenueName"]||'';
    data['EventVenueName'] = data["EventVenueName"]||'';
    data['EventAttendiesNames'] = data["EventAttendiesNames"]||'';
    return data;
  };

  validateAll=()=>{
    const { data } = this.state;
    return ((data.Name===undefined || data.Name==='') || (data.Description===undefined || data.Description==='')) ;
  };

  onSubmit=()=>{
    let data= {};
    let { buttonText,errors } = this.state;
    if(errors.LogoURL && errors.LogoURL!==''){
      this.props.showError(true,'Please Choose an Image File.');
    }
    else {
      if (buttonText === 'Update Event') {
        if(this.validateAll()) {
          this.props.showError(true, 'Please Fill All Fields Marked with *.');
        }else if(this.state.data.country==='')
          this.props.showError(true,'Please Select a proper Address.');
        else{
          data = this.createEditDictionary();
          this.props.onUpdateEvent(data);
          this.onCancel();
        }
      }
      else{
        if(this.validateAll()) {
          this.props.showError(true, 'Please Fill All Fields Marked with *.');
        }
        else if(this.state.data.country==='')
          this.props.showError(true,'Please Select a proper Address.');
        else{
          data = this.createDictionary();
          this.props.onCreateEvent(data);
          this.onCancel();
        }
      }
    }
  };

  onCancel=()=>{
    this.setState({
      data:{...this.state.Initial, LogoURL: '', tempURL: ''},
      buttonText:'Create Event',
      address:[],
      cancel:true,
      errors:[]
    });
  };

    handleAddressChange = (address) => {
        this.setState({
            address
        });
    };

    handleSelect = address => {
        this.setState({ address });
        geocodeByAddress(address)
            .then(results => {
                getLatLng(results[0]).then(latLng => {
                    this.handleAddressSelect({results:results,lat:latLng.lat,lng:latLng.lng});
                })
            })
            .catch(error => console.error('Error', error));
    };

  // LocationCustom=(props)=> {
  //   debugger;
  //   const {...other} = props;
  //   return (
  //     <Places
  //       {...other}
  //       onChange={this.handleAddressChange}
  //       address={this.state.address}
  //       handleSelect={this.handleSelect}
  //       cancel={this.state.cancel}
  //     />
  //
  //   );
  // };
  validate=(e)=>{
    const { name,value } = e.target;
    let { errors } = this.state;
    if(name==='Name') {
      if (!value)
        errors[name] = 'Please Enter Event Name.';
      else
        errors[name] = ''
    }
    else if(name==='Description') {
      if (!value)
        errors[name] = 'Please Enter Event Description.';
      else
        errors[name] = ''
    }
    this.setState({errors})
  };
  onError=(status,clearSuggestions)=>{
      console.log('Google Maps API returned error with status: ', status)
      clearSuggestions();
  }
  handleAddChange=()=>{

  }

  render(){
    const { classes,user } = this.props;
    const { data,buttonText,errors } = this.state;
    return(
      <Card
        header={
            <Grid container spacing={24} style={{ margin: 'auto 0' }}>
                <div style={{ paddingTop: '12px' }}>
                    <Avatar className={classes.avatar}>
                      {(user.results.AppUser.ProfileImage !== null && user.results.AppUser.ProfileImage !== "") ?
                        <img src={`https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${user.results.AppUser.ProfileImage}`} className="event-form-avatar-img"/>
                        :
                        <img className="event-form-avatar-img" src={require(`../../../images/Alphabets/${user.results.BusinessUser.BusinessName.match(/[a-z]/i)[0].toUpperCase()}.png`)} />
                      }
                    </Avatar>
                </div>
                <Grid item sm={6} xs={6}>
                    <div className='avatar-title-firstName'>
                      {user.results.AppUser.FirstName.charAt(0).toUpperCase() + user.results.AppUser.FirstName.substring(1)}
                    </div>
                    <div className='avatar-title-userName'>@{user.results.AppUser.UserName}</div>
                </Grid>
                <div className='potential-button-event'>
                        <span className='potential-button-inner-text'>
                            Your Event Has<br/>Potential Reach <br/>
                            of {(!this.props.potentialCount.countReceived)?
                            <CircularProgress size={15} className={classes.progress}/>
                            :
                            this.props.potentialCount.Count
                        } People
                        </span>
                </div>
                {/*<Grid item sm={4} xs={4} className="gridFont-event">*/}
                                    {/*</Grid>*/}
            </Grid>
        }
        CardHeaderProps={{
          style:{paddingBottom:0}
        }}
        CardContentProps={{
          style:{paddingTop:0}
        }}
        content={
            <Grid container>
                <div style={(this.props.progress)?{pointerEvents:'none'}:{}}>
                    <TextField
                      name="Name"
                      fullWidth={true}
                      InputLabelProps={{
                        className: classes.label,
                        shrink: true
                      }}
                      label={'1. Event Title *'}
                      inputProps={{
                        className: classes.textField
                      }}
                      margin={'normal'}
                      value={data.Name || ''}
                      onChange={this.handleChange}
                      onBlur={this.validate}
                    />
                  {(errors['Name']!=='')?<span className={'error'}>{errors['Name']}</span>:<span/>}
                    <TextField
                      name="Description"
                      fullWidth={true}
                      InputLabelProps={{
                        className: classes.label,
                        shrink: true
                      }}
                      label={'2. Description *'}
                      inputProps={{
                        className: classes.textField
                      }}
                      margin={'normal'}
                      value={data.Description || ''}
                      onChange={this.handleChange}
                      onBlur={this.validate}
                    />
                  {(errors['Description']!=='')?<span className={'error'}>{errors['Description']}</span>:<span/>}
                    <TextField
                      name="EventVenueName"
                      fullWidth={true}
                      InputLabelProps={{
                        className: classes.label,
                        shrink: true
                      }}
                      label={'3. Venue Name (Optional)'}
                      inputProps={{
                        className: classes.textField
                      }}
                      margin={'normal'}
                      value={data.EventVenueName || ''}
                      onChange={this.handleChange}
                    />
                  {/*<TextField
                            name="URL"
                            fullWidth={true}
                            InputLabelProps={{
                                className: classes.label,
                                shrink: true
                            }}
                            label={'4. Tickets URL (Optional)'}
                            inputProps={{
                                className: classes.textField
                            }}
                            placeholder={'www.example.com'}
                            margin={'normal'}
                            value={data.URL || ''}
                            onChange={this.handleChange}
                        />*/}
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DateTimePicker
                          fullWidth
                          color={'secondary'}
                          margin={'normal'}
                          label="4. Start Date And Time *"
                          InputLabelProps={{
                            className: classes.label,
                            shrink: true
                          }}
                          InputProps={{
                            className: classes.pickerFont,
                          }}
                          className={classes.picker}
                          onError={console.log}
                          value={moment(data.startDateTime)}
                          onChange={this.handleStartDate}
                          minDate={moment(new Date(),'MM/dd/yyyy hh:mm a').subtract(1,'months').format('yyyy-MM-dd')}
                          format="MM/dd/yyyy hh:mm a"
                          disableOpenOnEnter
                          mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/, ' ', /a|p/i, 'M']}
                        />
                        <DateTimePicker
                          fullWidth
                          color={'secondary'}
                          margin={'normal'}
                          label="5. End Date And Time *"
                          InputLabelProps={{
                            className: classes.label,
                            shrink: true
                          }}
                          InputProps={{
                            className: classes.pickerFont,
                          }}
                          onError={console.log}
                          className={classes.picker}
                          value={moment(data.endDateTime)}
                          minDate={moment().format('yyyy-MM-dd')}
                          onChange={this.handleEndDate}
                          format="MM/dd/yyyy hh:mm a"
                          disableOpenOnEnter
                          mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/, ' ', /a|p/i, 'M']}
                        />
                    </MuiPickersUtilsProvider>
                  {(errors['endDateTime']!=='')?<span className={'error'}>{errors['endDateTime']}</span>:<span/>}
                    <FormControl
                      margin={'normal'}
                      fullWidth={true}
                    >
                        <InputLabel className={classes.label}
                                    shrink={true}
                        >
                            6. Location *
                        </InputLabel>
                        <PlacesAutocomplete
                          value={this.state.address}
                          onChange={this.handleAddressChange}
                          onSelect={this.handleSelect}
                          shouldFetchSuggestions={true}
                          debounce={true}
                          onError={this.onError}
                          googleCallbackName={"initOne"}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                            <div>
                                <TextField
                                  {...getInputProps({
                                    margin:"normal",
                                    inputProps:{className: classes.inputText},
                                    fullWidth:true
                                  })}
                                />
                                <div>
                                  {suggestions.map(suggestion => {
                                    const className = suggestion.active
                                      ? 'suggestion-item'
                                      : 'suggestion-item';
                                    const style = suggestion.active
                                      ? { color: 'black', cursor: 'pointer' }
                                      : {  color: 'black',cursor: 'pointer' };
                                    return (
                                      <div
                                        {...getSuggestionItemProps(suggestion, {
                                          className,
                                          style,
                                        })}
                                      >
                                          <span>{suggestion.description}</span>
                                      </div>
                                    );
                                  })}
                                </div>
                            </div>
                          )}
                        </PlacesAutocomplete>
                      {/*<Autocomplete*/}
                        {/*style={{width: '90%'}}*/}
                        {/*onPlaceSelected={(place) => {*/}
                          {/*console.log(place);*/}
                        {/*}}*/}
                      {/*/>*/}
                      {/*<Input*/}
                      {/*name="location"*/}
                      {/*inputComponent={this.LocationCustom}*/}
                      {/*inputProps={{*/}
                      {/*className: classes.textField*/}
                      {/*}}*/}
                      {/*/>*/}
                    </FormControl>
                    <FormControl
                      margin={'normal'}
                      fullWidth={true}
                    >
                        <InputLabel className={classes.label}>7. Categories *</InputLabel>
                        <NativeSelect
                          fullWidth
                          value={data.eventCategoryId || data.EventCategoryId || '199'}
                          onChange={this.handleChange}
                          name="eventCategoryId"
                          className={classes.nativeSelect}
                        >
                          {categories.categories.map((c, i) => {
                            return (
                              <option key={i} value={c.id}>
                                {c.name}
                              </option>
                            )
                          })
                          }
                        </NativeSelect>
                    </FormControl>
                    <Grid item sm={12} className="custom-form-event-margin">
                        <div className='label-last'>
                            8. Upload Event Photo
                        </div>
                        <div className="file btn btn-primary">
                            Choose file to upload
                            <input type="file"
                                   name="LogoURL"
                                   accept='image/*'
                                   onChange={this.handleChange}
                            />
                        </div>
                        <span style={{marginLeft:'1%'}}>
                                {data.tempURL && <img src={data.tempURL} height={80} width={80} />}
                            </span>
                    </Grid>
                  {(errors['LogoURL']!=='')?<span className={'error'}>{errors['LogoURL']}</span>:<span/>}
                </div>
            </Grid>
        }
        actions={
            <Grid container justify={'flex-end'}>
                <Grid item sm={2}>
                    <div style={(this.props.progress)?{pointerEvents:'none'}:{}}>
                        <Button
                          fullWidth={true}
                          className="event-create-Button"
                          variant={'contained'}
                          onClick={this.onSubmit}
                          color={'primary'}
                        >
                          {buttonText}
                        </Button>
                    </div>
                </Grid>
                <Grid item sm={2}>
                    <div style={(this.props.progress)?{pointerEvents:'none'}:{}}>
                        <Button
                          fullWidth={true}
                          className={classes.cancelButton}
                          onClick={this.onCancel}
                        >
                            Cancel
                        </Button>
                    </div>
                </Grid>
            </Grid>
        }
        CardActionsProps={{
          style:{width:'100%',fontSize:'medium',paddingTop:0}
        }}
      />
    )
  }
}

const mapStateToProps=(state)=> {
  return {
    progress:state.progress
  }
};
export default connect(mapStateToProps,null)(withStyles(styles)(EventForm));